/* unplugin-vue-components disabled */import {computed} from 'vue'


export default {
  __name: 'highlight',
  props: {
  text: {
    type: String, required: false, default: ''
  },
  highlight: {
    type: String, required: false, default: ''
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const text = computed(() => props.text || '')
const highlight = computed(() => props.highlight || '')


const index = computed(
  () => text.value.toLowerCase().search($utils.regex.escapeRegex(highlight.value.toLowerCase()))
)

const __returned__ = { props, text, highlight, index, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}